module.exports = __webpack_public_path__ + "img/naan3.8c54ce78.jpg";